import { useState } from "react";

type Topic = { label: string; heat: number; tag: string };

const topics: Topic[] = [
  { label: "顶流深夜密会", heat: 98, tag: "实锤疑云" },
  { label: "塌房前兆清单", heat: 94, tag: "黑料" },
  { label: "爆款古偶杀青宴", heat: 88, tag: "剧组内幕" },
  { label: "前队友隔空开火", heat: 85, tag: "开撕" },
  { label: "热播综艺剧本门", heat: 81, tag: "内幕" },
  { label: "新晋小花恋情锤", heat: 76, tag: "恋情" },
  { label: "选秀C位退圈传闻", heat: 71, tag: "独家" },
  { label: "电竞选手转会风云", heat: 66, tag: "黑料" },
  { label: "直播间带货翻车", heat: 61, tag: "实锤" },
  { label: "剧组替身薪资内幕", heat: 55, tag: "内幕" },
  { label: "公关稿被锤穿帮", heat: 50, tag: "反转" },
  { label: "红毯主办方撕番", heat: 44, tag: "开撕" },
];

function sizeFor(heat: number) {
  if (heat >= 90) return "text-2xl md:text-3xl px-5 py-3.5 md:px-7 md:py-5";
  if (heat >= 80) return "text-lg md:text-xl px-4 py-3 md:px-6 md:py-4";
  if (heat >= 70) return "text-base px-4 py-2.5 md:px-5 md:py-3";
  return "text-sm px-3 py-2 md:px-4 md:py-2.5";
}

export default function TopicWall() {
  const [active, setActive] = useState<string | null>(null);

  return (
    <section id="topics" className="mt-20 bg-background-100/80 py-16 md:mt-24 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-6">
          {/* left intro */}
          <div className="lg:col-span-4">
            <p className="text-[11px] tracking-[0.25em] text-foreground-500 font-label">全网在聊什么</p>
            <h2 className="mt-3 font-serif text-3xl font-black text-foreground-950 md:text-4xl">
              话题热墙
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              这些词正被刷爆。热度越靠前，越多人蹲着等后续。点一下就跳到这口瓜所在的独家与猛料区。
            </p>
            <div className="mt-6 flex items-center gap-3 text-sm text-foreground-500">
              <i className="ri-sort-desc text-lg w-5 h-5 flex items-center justify-center text-primary-600" />
              按实时热度自动排位
            </div>
          </div>

          {/* tag wall */}
          <div className="lg:col-span-8">
            <ul className="flex flex-wrap gap-3 md:gap-4">
              {topics.map((t) => {
                const activeFlag = active === t.label;
                return (
                  <li key={t.label}>
                    <button
                      type="button"
                      onClick={() => setActive(activeFlag ? null : t.label)}
                      className={`${sizeFor(
                        t.heat
                      )} inline-flex items-center gap-2 rounded-full font-serif font-bold transition-all cursor-pointer border ${
                        activeFlag
                          ? "bg-primary-500 border-primary-500 text-background-50"
                          : "bg-background-50 border-background-300/60 text-foreground-800 hover:border-primary-300 hover:text-primary-700"
                      }`}
                    >
                      <span className="whitespace-nowrap">#{t.label}</span>
                      <span
                        className={`text-[10px] tracking-wide font-label font-medium px-2 py-0.5 rounded-full ${
                          activeFlag
                            ? "bg-background-50/20 text-background-50"
                            : "bg-secondary-100 text-secondary-900"
                        }`}
                      >
                        {t.heat}
                      </span>
                    </button>
                  </li>
                );
              })}
            </ul>
            <div className="mt-6 flex flex-wrap items-center gap-2 text-xs text-foreground-500 font-label">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-flashlight-fill text-primary-600 w-4 h-4 flex items-center justify-center" />
                实时抓取中，每 60 秒刷新一次排序
              </span>
              <span className="hidden sm:inline-block text-foreground-400">·</span>
              <span className="inline-flex items-center gap-1.5">
                已收录今日 <strong className="text-foreground-800">48</strong> 个高讨论话题
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}